import React, { useState, useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import Widget from 'components/Widget'
import IntlMessages from "util/IntlMessages"
import { Form, Input, Row, Col, Button, InputNumber, message, Spin, Space, Divider, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import { DataRequestAction, DataGetAction } from 'redux/actions/http';
import { intlPlaceholder } from "util/intlPlaceholder"
import SimpleModal from 'components/Modal/SimpleModal'
import AvatarUploader from 'components/AvatarUploader'
import dummyImage from 'assets/images/dummyImage.jpeg'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import  RenewPlan from './components/RenewPlan'
import { useHistory } from 'react-router-dom';
import { logoutFn } from 'redux/actions/Common'
const { Text } = Typography;

const Index = () => {

    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const { role, memberShipPlan } = userInfo
    console.log('================userInfo===========', userInfo)
    const dispatch = useDispatch()
    const history = useHistory()
    let initialState = {
        loading: false,
        imageUrl: '',
    }
    const [photoList, setPhotoState] = useState(initialState)
    const settingsProps = useSelector(state => state.adminSettings)
    const { changePasswordModelVisible, editProfileModalVisible, isPlanSettingsUpdated, textMessage, isPlanSettingsFail, settingsData, fetchingLoader, isPasswordChanged, profileEditeSuccess } = settingsProps


    const patientProps = useSelector(state => state.clientDashboard)
    const {  PlaneUnSubscribePlane } = patientProps;
    const patientInfo = patientProps && patientProps.patientInfo && patientProps.patientInfo.length && patientProps.patientInfo[0]
    const planInfo = patientInfo && patientInfo.planInfo && patientInfo.planInfo.length && patientInfo.planInfo[0]
    const renewalDate = planInfo.planeRenewalDate
    console.log('================renewalDate===========', renewalDate)
    

    if (PlaneUnSubscribePlane) {
        console.log("============ PlaneUnSubscribePlane", PlaneUnSubscribePlane);
        dispatch(DataGetAction('logout', '', 'loggingOut'));
        dispatch(logoutFn());
        history.push('/')
        dispatch({
            type: 'update_auth'
        });

        dispatch({
            type: 'reset_unsubscribe'
        })

    }

    const fetchSettings = () => {
        dispatch(DataGetAction('getProfile', '', 'gettingProfile'));
        dispatch(DataGetAction('getPatientInfo', '', 'gettingPatientInfo'))
        if (settingsData.profileImageUrl) {
            photoList.imageUrl = settingsData.profileImageUrl
        }
    }

    useEffect(fetchSettings, [settingsData.profileImageUrl]);


    const updateProfle = values => {
        values.profileImageUrl = photoList.imageUrl
        dispatch(DataRequestAction('PUT', 'updateProfile', values, '', 'updatingProle', false))
    };


    const changePassword = values => {
        dispatch(DataRequestAction('POST', 'resetPassword', values, '', 'changingPassword', false))
    };

    const updateSetting = values => {
        dispatch(DataRequestAction('PUT', 'updateSetting', values, '', 'planningSettings', false))
    };

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const toggleChangePasswordModal = () => {
        dispatch({
            type: 'changePassword_Modal'
        })
    }

    const toggleEditProfile = () => {
        dispatch({
            type: 'EditProfile_Modal'
        })
    }
    if (isPlanSettingsUpdated) {
        dispatch({
            type: 'reset_profilesettings'
        })
        message.success(textMessage)

    }
    if (isPlanSettingsFail) {
        message.error(textMessage)
    }
    if (isPasswordChanged) {
        message.success(textMessage)
        dispatch({
            type: 'reset_profilesettings'
        })

    }
    if (profileEditeSuccess) {
        message.success(textMessage)
        dispatch({
            type: 'reset_profilesettings'
        })
    }

    const renderPlan = () => {
        
        if (memberShipPlan === 'premium') {
            return <div className="gx-d-flex gx-align-items-center">
            <span className="icon icon-close-circle" style={{ color: '#0D7DD9', fontSize: '20px' }}></span>
            <div className="details gx-ml-3 gx-d-flex gx-flex-column">
            
                <RenewPlan renewalDate={renewalDate} />
            </div>
        </div>
        }
    }
    return (
        <Layout>

            {fetchingLoader ?
                <Spin size="large" color="blue" />
                :
                <>
                    <Row>
                        {role !== 'client' && <Col xl={13} lg={13} md={24} sm={24} xs={24}>
                            <Widget 
                                styleName="membership-container" 
                                title={<IntlMessages id="settings.membershipPlanSetting" />}
                                
                                >
                                <Form
                                    layout="horizontal"
                                    name="updateSetting"
                                    onFinish={updateSetting}
                                    {...layout}
                                    initialValues={settingsData && settingsData.planeSettings}

                                >

                                    <Row>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <Form.Item
                                                name="planName1"
                                                label={<IntlMessages id="settings.planName1" />}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <IntlMessages id="settings.planName1_message" />,
                                                    },
                                                ]}

                                            >
                                                <Input placeholder={intlPlaceholder('settings.planName1_placeholder')} />
                                            </Form.Item>
                                        </Col>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >

                                            <Form.Item
                                                name="planName1Price"
                                                label={<IntlMessages id="settings.price1" />}
                                                rules={[
                                                    {

                                                        required: true,
                                                        message: <IntlMessages id="settings.price1_message" />,
                                                    },
                                                ]}

                                            >
                                                <InputNumber formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder={intlPlaceholder('settings.price1_placeholder')} />
                                            </Form.Item>
                                        </Col>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <Form.Item
                                                name="planName1GST"
                                                label={<IntlMessages id="settings.GST1" />}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <IntlMessages id="settings.GST1_message" />,
                                                    },
                                                ]}

                                            >
                                                <InputNumber formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder={intlPlaceholder('settings.GST1_placeholder')} />
                                            </Form.Item>
                                        </Col>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <Form.Item
                                                name="planName2"
                                                label={<IntlMessages id="settings.planName2" />}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <IntlMessages id="settings.planName2_message" />,
                                                    },
                                                ]}
                                            >
                                                <Input placeholder={intlPlaceholder('settings.planName2_placeholder')} />
                                            </Form.Item>
                                        </Col>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <Form.Item
                                                name="planName2Price"
                                                label={<IntlMessages id="settings.price2" />}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <IntlMessages id="settings.price2_message" />,
                                                    },
                                                ]}

                                            >
                                                <InputNumber formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder={intlPlaceholder('settings.price2_placeholder')} />
                                            </Form.Item>
                                        </Col>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <Form.Item
                                                name="planName2GST"
                                                label={<IntlMessages id="settings.GST2" />}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <IntlMessages id="settings.GST2_message" />,
                                                    },
                                                ]}

                                            >
                                                <InputNumber formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder={intlPlaceholder('settings.GST2_placeholder')} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">


                                                <Form.Item className="gx-mb-0">
                                                    <Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="submit">
                                                        <IntlMessages id="settings.saveChanges" />
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </Widget>
                        </Col>}
                        <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                            <Widget>
                                <div className="gx-d-flex gx-align-items-center">
                                    {settingsData && settingsData.profileImageUrl ? <img src={settingsData && settingsData.profileImageUrl} alt="" style={{ width: '50px', height: '50px', borderRadius: "50%" }} /> : <img src={dummyImage} alt="" style={{ width: '50px', height: '50px', borderRadius: "50%" }} />}
                                    
                                    

                                    {role !== 'client' ? <div className="details gx-ml-3">
                                        <span className="gx-font-sans-bold" style={{ color: '#595959' }}>
                                            <span>{settingsData && settingsData.firstName}</span>
                                            <span className="gx-ml-1">{settingsData && settingsData.lastName}</span>
                                        </span>
                                    </div> :
                                        <span className="gx-font-sans-bold" style={{ color: '#595959', marginLeft: '10px' }}>
                                            <span>{settingsData && settingsData.fullName}</span>

                                        </span>

                                    }
                                    
                                </div>
                                <div className="gx-d-flex gx-justify-content-between gx-my-4">
                                    <div className="gx-d-flex gx-align-items-center">
                                        <span className="icon icon-email" style={{ color: '#0D7DD9', fontSize: '20px' }}></span>
                                        <div className="details gx-ml-3 gx-d-flex gx-flex-column">
                                            <span style={{ color: '#D2D2D2' }}> <IntlMessages id="settings.profile.email" /></span>
                                            <span style={{ color: '#595959' }}>{settingsData && settingsData.email}</span>
                                        </div>
                                    </div>

                                    <Button type="primary" className="gx-m-0 gx-pt-0" onClick={() => toggleChangePasswordModal()}><IntlMessages id="settings.profile.changePassword" /></Button>
                                </div>

                                <div className="gx-d-flex gx-justify-content-between">
                                    <div className="gx-d-flex gx-align-items-center">
                                        <span className="icon icon-phone" style={{ color: '#0D7DD9', fontSize: '20px' }}></span>
                                        <div className="details gx-ml-3 gx-d-flex gx-flex-column">
                                            <span style={{ color: '#D2D2D2' }}><IntlMessages id="settings.profile.phone" /></span>
                                            <span style={{ color: '#595959' }}>+{settingsData && settingsData.phoneNumber}</span>
                                        </div>
                                    </div>

                                    <Button className="gx-m-0 gx-pt-0" onClick={() => toggleEditProfile()}><IntlMessages id="settings.profile.edit" /></Button>
                                </div>
                               
                                {role === 'client' ? <div className="gx-d-flex gx-justify-content-between gx-my-4">
                                    <div className="gx-d-flex gx-align-items-center">
                                        <span className="icon icon-email" style={{ color: '#0D7DD9', fontSize: '20px' }}></span>
                                        <div className="details gx-ml-3 gx-d-flex gx-flex-column">
                                            <span style={{ color: '#D2D2D2' }}> <IntlMessages id="settings.profile.EmailForDailyReport" /></span>
                                            {settingsData && settingsData.dailyReportEmail && settingsData.dailyReportEmail.length && settingsData.dailyReportEmail.map((Item) => {
                                                return <span style={{ color: '#595959' }}>{Item.email}</span>
                                            })}
                                        </div>
                                    </div>

                                </div> : ""}
                                {renderPlan()}
                            </Widget>
                        </Col>
                    </Row>




                    <SimpleModal width={500} title={
                        <span style={{ color: '#041649' }} className="gx-font-sans-bold">{<IntlMessages id="settings.passwordModal.changePassword" />} </span>
                    }
                        modalFor="changePassword_Modal"
                        visible={changePasswordModelVisible}>

                        <span></span>
                        <Form
                            layout="vertical"
                            name="resetPasswprd"
                            onFinish={changePassword}

                        >



                            <Row>
                                <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-px-0">
                                    <Form.Item
                                        name="oldPassword"
                                        label={<IntlMessages id="settings.passwordModal.currentPassword" />}
                                        rules={[
                                            {
                                                required: true,
                                                message: <IntlMessages id="settings.passwordModal.currentPassword_message" />,
                                            },
                                        ]}

                                    >
                                        <Input.Password />
                                    </Form.Item>
                                </Col>
                            </Row>


                            <Row className="gx-d-flex gx-flex-row">
                                <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-px-0">
                                    <Form.Item
                                        name="password"
                                        label={<IntlMessages id="settings.passwordModal.newPassword" />}
                                        rules={[
                                            {
                                                required: true,
                                                message: <IntlMessages id="settings.passwordModal.newPassword_message" />,
                                            },
                                        ]}

                                    >
                                        <Input.Password />
                                    </Form.Item>
                                </Col>
                                <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-px-0">

                                    <Form.Item
                                        name="confirmPassword"
                                        label={<IntlMessages id="settings.passwordModal.confirmPassword" />}
                                        dependencies={['password']}

                                        rules={[
                                            {
                                                required: true,
                                                message: <IntlMessages id="settings.passwordModal.confirmPassword_message" />,
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(rule, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(<IntlMessages id="settings.passwordModal.passwordNotMatchMessage" />);
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                                    <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">

                                        <Form.Item className="gx-mb-0">
                                            <Button type="default" className="gx-pt-0 gx-mb-0 gx-mr-2" htmlType="button" onClick={() => toggleChangePasswordModal()}>
                                                <IntlMessages id="settings.passwordModal.cancel" />
                                            </Button>
                                        </Form.Item>
                                        <Form.Item className="gx-mb-0">
                                            <Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="submit">
                                                <IntlMessages id="settings.passwordModal.save" />
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </SimpleModal>



                    <SimpleModal width={500} title={
                        <span style={{ color: '#041649' }} className="gx-font-sans-bold">{<IntlMessages id="settings.editModal.updateProfile" />} </span>
                    }
                        modalFor="EditProfile_Modal"
                        visible={editProfileModalVisible}>

                        <span></span>
                        <Form
                            layout="vertical"
                            name="editProfile"
                            onFinish={updateProfle}
                            initialValues={settingsData && settingsData}
                        >



                            <Row className="gx-d-flex gx-flex-row gx-align-items-center">
                                <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-pl-0">

                                    {role !== 'client' ?
                                        <>
                                            <Form.Item
                                                name="firstName"
                                                label={<IntlMessages id="settings.editModal.firstName" />}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <IntlMessages id="settings.editModal.firstName_message" />,
                                                    },
                                                ]}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                name="lastName"
                                                label={<IntlMessages id="settings.editModal.lastName" />}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: <IntlMessages id="settings.editModal.lastName_message" />,
                                                    },
                                                ]}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </> :
                                        <Form.Item
                                            name="fullName"
                                            label={<IntlMessages id="settings.editModal.fullName" />}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: <IntlMessages id="settings.editModal.fullName_message" />,
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>

                                    }
                                    <Form.Item
                                        name="email"
                                        label={<IntlMessages id="settings.editModal.email" />}
                                        rules={[
                                            {
                                                type: 'email',
                                                required: true,
                                                message: <IntlMessages id="settings.editModal.email_message" />,
                                            },
                                        ]}

                                    >
                                        <Input disabled />
                                    </Form.Item>

                                    <Form.Item
                                        name="phoneNumber"
                                        label={<IntlMessages id="settings.editModal.phone" />}
                                        rules={[
                                            {
                                                required: true,
                                                message: <IntlMessages id="settings.editModal.phone_message" />,
                                            },
                                        ]}

                                    >
                                        <Input />
                                    </Form.Item>





                                </Col>
                                <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-pr-0">
                                    <Form.Item
                                        name="photo"
                                    >
                                        <AvatarUploader setPhotoState={setPhotoState} photoList={photoList} />
                                    </Form.Item>
                                </Col>
                            </Row>



                            <Row>
                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                                    <Divider>Email For Daily Report</Divider>
                                </Col>
                                {
                                    role === 'client' && memberShipPlan !== 'free'  ? <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">

                                        <Form.List name="dailyReportEmail">
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map(({ key, name, fieldKey, ...restField }) => (
                                                        <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'email']}
                                                                fieldKey={[fieldKey, 'email']}
                                                            >
                                                                <Input placeholder="Email" />
                                                            </Form.Item>
                                                            <MinusCircleOutlined onClick={() => remove(name)} />
                                                        </Space>
                                                    ))}
                                                    {fields.length < 5 && <Form.Item>
                                                        <Button className="gx-pt-0" type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                            Add Email For Daily Report
                                                            </Button>
                                                    </Form.Item>}
                                                </>
                                            )}
                                        </Form.List>

                                    </Col> : <Text mark>You are not allow to add the email for daily report. update your plan for use this feature</Text>
                                }
                            </Row>
                            <Row>
                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                                    <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">

                                        <Form.Item className="gx-mb-0">
                                            <Button type="default" className="gx-pt-0 gx-mb-0 gx-mr-2" htmlType="button" onClick={() => toggleEditProfile()}>
                                                <IntlMessages id="settings.editModal.cancel" />
                                            </Button>
                                        </Form.Item>
                                        <Form.Item className="gx-mb-0">
                                            <Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="submit">
                                                <IntlMessages id="settings.editModal.save" />
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </SimpleModal>

                </>
            }
        </Layout>
    )
}

export default Index
